<template>
    <form>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PairObj.symbol"
                    :label="$t('pairs.table_titles.symbol')"
                    :error="PairObj.errors.has('symbol')"
                    :error-message="PairObj.errors.get('symbol')"
                    input-class="text-center"
                    color="input-color"
                    hint="Ex: USDT-VND"
                />
            </div> <!-- SYMBOL -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-select
                    v-model="PairObj.exchange_id"
                    :label="$t('pairs.table_titles.exchange')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="name"
                    :options="exchanges"
                    :loading="loading"
                    :error="PairObj.errors.has('exchange_id')"
                    :error-message="PairObj.errors.get('exchange_id')"
                    color="input-color"
                >
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #eee"
                        >
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium">{{ scope.opt.name }}</span>
                                    <span class="text-caption">{{ scope.opt.class_name ? ' (API-available)' : '' }}</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- EXCHANGE -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PairObj.bid_rate"
                    :label="$t('pairs.table_titles.bid_rate')"
                    :error="PairObj.errors.has('bid_rate')"
                    :error-message="PairObj.errors.get('bid_rate')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                />
            </div> <!-- BID RATE -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PairObj.ask_rate"
                    :label="$t('pairs.table_titles.ask_rate')"
                    :error="PairObj.errors.has('ask_rate')"
                    :error-message="PairObj.errors.get('ask_rate')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                />
            </div> <!-- ASK RATE -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PairObj.slippage_percent"
                    label="Slippage percent"
                    :error="PairObj.errors.has('slippage_percent')"
                    :error-message="PairObj.errors.get('slippage_percent')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <q-icon name="fa fa-percentage" />
                    </template>
                </q-input>
            </div> <!-- SAFETY MARGIN PERCENT -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="PairObj.slippage_amount"
                    label="Slippage amount"
                    :error="PairObj.errors.has('slippage_amount')"
                    :error-message="PairObj.errors.get('slippage_amount')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <q-icon name="fa fa-dollar-sign" />
                    </template>
                </q-input>
            </div> <!-- SAFETY MARGIN AMOUNT -->
            <div class="col col-xs-12 col-sm-6 col-md-4">
                <p class="text-caption q-pb-xs" style="margin:0">Get price via API</p>
                <q-toggle
                    v-model="PairObj.is_api_enabled"
                    color="positive"
                    :label="PairObj.is_api_enabled ? 'Active' : 'Inactive'"
                    :disable="!hasSelectedExchangeClassName"
                />
            </div> <!-- IS API ENABLED -->
            <div class="col col-xs-12 col-sm-6 col-md-4">
                <p class="text-caption q-pb-xs" style="margin:0">Rate health check</p>
                <q-toggle
                    v-model="PairObj.is_rate_ok"
                    color="positive"
                    :label="PairObj.is_rate_ok ? 'Normal' : 'Abnormal'"
                />
            </div> <!-- IS RATE OK -->
        </div>
    </form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'Form',
    model: {
        prop: 'PairObj',
        event: 'change'
    },
    props: {
        PairObj: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['exchanges']),
        hasSelectedExchangeClassName() {
            return this.PairObj.exchange_id && this.exchanges.length ? !!this.exchanges.find(exchange => exchange.id === this.PairObj.exchange_id).class_name : false
        },
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapActions(['set_exchanges']),
    },
    created() {
        if (! this.exchanges.length) {
            this.loading = true
            this.set_exchanges().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }
    },
    components: {},
}
</script>

<style scoped>

</style>
